import React from 'react';
import { Box, Card, CardContent, CardActions, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import WorkspaceIcon from '@mui/icons-material/AppsRounded';
import ProjectIcon from '@mui/icons-material/StyleRounded';
import LibraryIcon from '@mui/icons-material/CollectionsBookmarkRounded';
import ExploreIcon from '@mui/icons-material/TravelExploreRounded';
import ChartIcon from '@mui/icons-material/GridOnRounded';

export default function Home() {
  const sections = [
    {
      title: 'Workspaces',
      description: 'Manage and explore your workspaces.',
      link: '/workspaces',
      icon: <WorkspaceIcon sx={{ fontSize: 40, color: 'primary.main' }} />
    },
    {
      title: 'Projects',
      description: 'Track and organize your projects.',
      link: '/projects',
      icon: <ProjectIcon sx={{ fontSize: 40, color: 'primary.main' }} />
    },
    {
      title: 'Library',
      description: 'Browse and manage your library items.',
      link: '/library',
      icon: <LibraryIcon sx={{ fontSize: 40, color: 'primary.main' }} />
    },
    {
      title: 'Explore',
      description: 'Discover and connect with other creators.',
      link: '/explore',
      icon: <ExploreIcon sx={{ fontSize: 40, color: 'primary.main' }} />
    },
    {
      title: 'Chart Editor',
      description: 'Try the new chart editor.',
      link: '/knit-chart-playground',
      icon: <ChartIcon sx={{ fontSize: 40, color: 'secondary.main' }} />
    }
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' }, // 1 column on small screens, 2 columns on larger screens
        gap: 2,
        p: 2,
        justifyContent: 'center'
      }}
    >
      {sections.map((section, index) => (
        <Card
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 2,
            textAlign: 'center'
          }}
        >
          {section.icon}
          <CardContent>
            <Typography variant="h5" sx={{ mt: 1, mb: 1 }}>
              {section.title}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              {section.description}
            </Typography>
          </CardContent>
          <CardActions>
            <Button variant="outlined" color="primary" component={Link} to={section.link}>
              Go to {section.title}
            </Button>
          </CardActions>
        </Card>
      ))}
    </Box>
  );
}
